import { observer } from 'mobx-react-lite';
import React, { FC } from 'react';
import { useLocation, Navigate, matchPath } from 'react-router-dom';
import { PAGE_ROUTE } from 'src/constants/route';
import useStore from 'src/hooks/useStore';
import { IAuthStore } from 'src/store/auth/auth.store';

interface IProtected {
	children: React.ReactElement;
}
const Protected: FC<IProtected> = observer(({ children }: IProtected) => {
	const autStore: IAuthStore = useStore<IAuthStore>('authStore');

	const location = useLocation();
	
	if (!autStore.isAuthenticated){
		if(!matchPath('/otp/', location.pathname)){
			autStore.setPreAuthLocation(
				{
					path: location.pathname,
					search: location.search
				}
			)
		}
		return <Navigate to={PAGE_ROUTE.LOGIN} replace />;
	}
	return children;
});

export default Protected;
